export const analyticsPageNames = {
    appointments: {
        appointment: 'Non-flow - Review an appointment',
        chat: 'Non-flow - Appointment Chat',
        main: 'Non-flow - Appointments tab',
        proReview: 'Non-flow - Rate and Review',
        unavailable: 'Appointment - Unavailable beauty pro',
        cancellationError: 'Appointment - Could not cancel appointment',
        cancelledAppointment: 'Non-flow - Cancel Appt'
    },
    booking: {
        addOns: 'New 6 and Exist 7 Flow - Add-ons',
        friends: 'New 7 and Exist 8 Flow - Add friends',
        locationConfirm: 'Exist 3 Flow - Confirm location',
        locationNew: 'Potential Flow - Change location',
        emailCapture: 'Booking - Email Capture',
        payment: 'Potential Flow - Change payment',
        proList: 'New 4 and Exist 5 Flow - View all pros',
        review: 'New 8 and Exist 9 Flow - Review request',
        reviewPromoCode: 'Promo code',
        time: 'New 3 and Exist 4 Flow - Choose start time',
        timeAlt: 'Potential Flow - Choose alternate times',
        newUserRegistration: 'New 8 and Exist 9 Flow - Review request signup',
        newUserInfo: 'New 9 Flow - Signup my info',
        newUserLocation: 'New 10 Flow - Signup my location',
        newUserPayment: 'Potential Flow - Change payment',
        newUserReviewPage: 'New 8 and Exist 9 Flow - Review request',
        bookingCompleted: 'New 11 and Exist 10 Flow - Request submitted'
    },
    discover: {
        home: 'New 1 and Exist 1 Flow - Discover page',
        services: 'New 2 and Exist 2 Flow - Pick main service'
    },
    faqLink: 'Non-flow - Primped FAQ sub-tab',
    favorites: 'Potential Flow - Favorite pros list',
    forgotPassword: 'Non-flow - Forgot Password',
    login: 'Potential Flow - Log In',
    logout: 'Non-flow - Logout',
    notifications: {
        list: 'Non-flow - Notifications'
    },
    proProfile: {
        gallery: "Potential Flow - Chosen pro's portfolio",
        proProfile: 'New 5 and Exist 6 Flow - Chosen pro',
        reviews: "Potential Flow - Chosen pro's list of reviews",
        bookingProProfile: 'New 5 and Exist 6 Flow - Chosen pro'
    },
    profile: {
        beauty: 'Non-flow - Beauty profile sub-tab',
        main: 'Non-flow  - Profile tab',
        medical: 'Non-flow - Medical concerns sub-tab',
        password: 'Non-flow - Password sub-tab',
        phoneEmail: 'Non-flow - Phone and email sub-tab',
        profileEdit: 'Non-flow - Profile sub-tab',
        settings: 'Non-flow - Profile and settings sub-tab'
    },
    register: {
        user: 'Register - User',
        location: 'Register - Location',
        additionalInfo: 'Register - Additional Information'
    },
    report: 'Non-flow - Help/report an issue tab',
    requests: {
        change: 'Non-flow - Change Request',
        special: 'Non-flow - Special Request'
    },
    welcome: 'Potential Flow - Welcome'
};
